import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import * as schemas from "../../../assets/schemas/schemas";
import { LoginForm, LoginOTPForm } from "../../common/Forms/Form";
import { useHistory } from "react-router-dom";
import { LogoButton, } from "../../common/Buttons/Buttons";
import logo from "../../../images/logo.svg";
import { loginService } from "../../../services/loginService.js";
import { notify } from "../../../assets/helpers/toast";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner";
import { operationsRoles } from "../../../assets/helpers/roles.js";
import "./Login.scss";

export const Login = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.LoginSchema(t)),
  });


  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
  } = useForm({
    resolver: yupResolver(schemas.LoginOTPSchema()),
  });


  const [isLoading, setIsloading] = useState(false);
  const [otpForm, setOTPForm] = useState(false);

  let history = useHistory();
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    // history.push('/services');
    setIsloading(true);
    loginService
      .loginOTP(data)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.tokens?.accessToken) {
            login(response)
            return null
          } else {
            setOTPForm(true)
            setValue2("userId", response.data.userId)
            notify(`Ingrese el código de seguridad que fue enviado a su correo`, 'success');
            setIsloading(false)
            return
          }
        }
        if (response.status === 401) {
          notify(`Usuario o contraseña incorrectos`, "error");
          setIsloading(false);
          setValue("password", "");
          return
        }
        else {
          notify(`${response.message}`, "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  });


  const login = (response) => {
    sessionStorage.setItem(
      `accessToken`,
      response?.data?.tokens?.accessToken
    );
    sessionStorage.setItem(
      `refreshToken`,
      response?.data?.tokens?.refreshToken
    );
    sessionStorage.setItem(`user`, JSON.stringify(response?.data?.user));

    sessionStorage.setItem(
      `assignedVehicle`,
      JSON.stringify(response?.data?.vehicle)
    );

    if (
      [operationsRoles.OPERATIONS_FLOTA_GRUA_EXT,
      operationsRoles.OPERATIONS_FLOTA_GRUA,
      operationsRoles.OPERATIONS_FLOTA_AV
      ].includes(response?.data?.user?.roles[0]?.code)
    ) {
      history.push("/providers-stats");
    } else {
      history.push("/services");
    }
    setIsloading(false);
  }

  const onSubmit2 = handleSubmit2(async (data) => {
    setIsloading(true);
    loginService
      .loginOTPValidate(data)
      .then((response) => {
        if (response.status === 200) {
          login(response)
        } else {
          notify(`${response.message}`, "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  });


  const preloadInputs = () => {
    let develop = process.env.REACT_APP_DEVELOP;

    if (develop == "true") {
      setValue("email", process.env.REACT_APP_OPERATIONS_USER);
      setValue("password", process.env.REACT_APP_OPERATIONS_PASSWORD);
    }
  };

  useEffect(() => {
    preloadInputs();
  }, []);

  return (
    <>
      <LoadSpinner label={"Iniciando Sesión"} show={isLoading} />
      <div className="container view-content">
        <div className="row">
          <div className="col-12 login-page-container">
            <div className="login-form">
              <div className="login-logo-container">
                <LogoButton link={"/"} src={logo} />
                <br />
                <h5>Módulo de Operaciones </h5>
                <div className="horizontal-bar-container">
                  <div></div>
                </div>
              </div>
              {!otpForm &&
                <LoginForm
                  t={t}
                  register={register}
                  errors={errors}
                  action={onSubmit}
                />
              }
              {otpForm &&
                <LoginOTPForm
                  t={t}
                  register={register2}
                  errors={errors2}
                  action={onSubmit2}
                />
              }
              {/* <div className="register-call-to-action-container">
                ¿No tienes una cuenta? {'    '}
                <NavLink to={'/sign-up'}>Regístrate</NavLink>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
